import { buildPlatformAccessMap } from '@/permissions/adapter';

/**
 * 平台 RBAC：权限由 YeeAuth 按账号授予，access 的键为 `资源:操作`（管理隐含查看）。
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { platformPermissions?: string[] } | undefined,
) {
  const permissions = initialState?.platformPermissions ?? [];
  return {
    ...buildPlatformAccessMap(permissions),
    hasPlatformPermission: permissions.length > 0,
  };
}
